document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('complete-look-form');
  if (!form) return;

  const mainProductInput = form.querySelector('.main-product-input');
  const checkboxes = form.querySelectorAll('.product-checkbox');
  const summaryDiv = document.getElementById('selected-summary');
  const summaryItems = document.getElementById('summary-items');
  const totalPriceSpan = document.getElementById('total-price');
  const submitButton = document.getElementById('add-look-to-cart');

  const BUTTON_LABEL = 'Adicionar ao carrinho';
  const BUTTON_LABEL_LOADING = 'Adicionando ao carrinho...';

  /** Safe formatMoney with fallback */
  const formatMoney =
    typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function'
      ? Shopify.formatMoney
      : function (cents) {
          return (cents / 100).toFixed(2);
        };

  const moneyFormat = window.theme?.moneyFormat || '{{amount}}';

  /** Safe fetchConfig with fallback */
  function getfetchConfig() {
    if (typeof fetchConfig === 'function') {
      return fetchConfig();
    }
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };
  }

  /** Extract text from HTML string (handles HTML entities from formatMoney) */
  function moneyToText(cents) {
    const temp = document.createElement('div');
    temp.innerHTML = formatMoney(cents, moneyFormat);
    return temp.textContent || temp.innerText || '';
  }

  /** Gather all selected products: main (always) + checked related */
  function getSelectedProducts() {
    const products = [];

    // Main product is always included
    if (mainProductInput) {
      products.push({
        title: mainProductInput.dataset.title,
        price: parseInt(mainProductInput.dataset.price, 10),
        variantId: mainProductInput.dataset.variantId,
      });
    }

    // Related products based on checkbox state
    checkboxes.forEach(function (checkbox) {
      if (checkbox.checked && !checkbox.disabled) {
        products.push({
          title: checkbox.dataset.title,
          price: parseInt(checkbox.dataset.price, 10),
          variantId: checkbox.dataset.variantId,
        });
      }
    });

    return products;
  }

  function updateSummary() {
    const selectedProducts = getSelectedProducts();
    let totalPrice = 0;

    // Clear existing items
    summaryItems.innerHTML = '';

    if (selectedProducts.length > 0) {
      selectedProducts.forEach(function (product) {
        totalPrice += product.price;

        const summaryItem = document.createElement('div');
        summaryItem.className = 'summary-item';

        const titleSpan = document.createElement('span');
        titleSpan.textContent = product.title;

        const priceSpan = document.createElement('span');
        priceSpan.textContent = moneyToText(product.price);

        summaryItem.appendChild(titleSpan);
        summaryItem.appendChild(priceSpan);
        summaryItems.appendChild(summaryItem);
      });

      totalPriceSpan.textContent = 'R$ ' + moneyToText(totalPrice);
      summaryDiv.style.display = '';
    } else {
      summaryDiv.style.display = 'none';
    }

    // Disable button only if no related products are checked
    // (main product is always included, so at minimum 1 product exists)
    const hasRelatedSelected = Array.from(checkboxes).some(function (cb) {
      return cb.checked && !cb.disabled;
    });
    submitButton.disabled = !hasRelatedSelected && !mainProductInput;
  }

  checkboxes.forEach(function (checkbox) {
    checkbox.addEventListener('change', updateSummary);
  });

  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    const selectedProducts = getSelectedProducts();

    if (selectedProducts.length === 0) {
      alert('Por favor, selecione pelo menos um produto.');
      return;
    }

    submitButton.disabled = true;
    submitButton.textContent = BUTTON_LABEL_LOADING;

    // Deduplicate by variant ID
    const variantCounts = {};
    selectedProducts.forEach(function (product) {
      const vid = product.variantId;
      variantCounts[vid] = (variantCounts[vid] || 0) + 1;
    });

    const items = Object.keys(variantCounts).map(function (variantId) {
      return {
        id: parseInt(variantId, 10),
        quantity: variantCounts[variantId],
      };
    });

    try {
      const config = getfetchConfig();

      const addResponse = await fetch(routes.cart_add_url, {
        ...config,
        body: JSON.stringify({ items }),
      });

      if (!addResponse.ok) {
        const errorData = await addResponse.json().catch(function () {
          return {};
        });
        throw new Error(errorData.description || 'Erro ao adicionar ao carrinho.');
      }

      const cartData = await addResponse.json();

      // Fetch updated section HTML for cart drawer
      const updateResponse = await fetch(routes.cart_update_url, {
        ...config,
        body: JSON.stringify({
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      });

      const parsedState = JSON.parse(await updateResponse.text());

      // Single cart:updated dispatch with consistent payload
      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: { cart: cartData },
        }),
      );

      document.dispatchEvent(new CustomEvent('cart:refresh'));

      // Open cart drawer with fresh data
      const cartDrawerElement = document.querySelector('cart-drawer');
      if (cartDrawerElement && typeof cartDrawerElement.renderContents === 'function') {
        cartDrawerElement.classList.remove('is-empty');
        cartDrawerElement.classList.add('active');
        cartDrawerElement.renderContents(parsedState);
      }
    } catch (error) {
      console.error('Complete the look — add to cart error:', error);
      alert(error.message || 'Não foi possível adicionar ao carrinho. Tente novamente.');
    } finally {
      submitButton.disabled = false;
      submitButton.textContent = BUTTON_LABEL;
    }
  });

  updateSummary();
});
